import React, { useState, useEffect, useRef } from 'react'
import { 
    Layout,
    Col, 
    Row,
    Image,
    Button,
    Space,
    // Table,
} from 'antd';
import Navbar from '../../Components/Navbar/Navbar';
import { HashLoader } from 'react-spinners';
// import HeaderImage from '../../Assets/Images/CPM-HEADER-cropped-1.png'
// import html2canvas from 'html2canvas';
// import jsPDF from "jspdf";
// import TenantSignature from "../../Assets/Images/tenant_signature.png"
// import OwnerSignature from "../../Assets/Images/owner_signature.png"

import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
// import { usePostRequest } from '../../hooks/usePostRequest'
// import { useReactToPrint } from "react-to-print";
import { 
    formatAmount, 
    formatDate,
    TypeTag, 
    // refreshPage, 
    // extractDateTime 
} from '../../Utils/Common';
// import { 
//     ProductOutlined,
// } from '@ant-design/icons';
// import { SeeAttachment } from '../../Components/SeeAttachment';
import { PreviewTable } from '../../Components/PreviewTable';

const PreviewPayment = () => {
    const navigate = useNavigate()
    // const currentDate = new Date();
    const { id } = useParams();
    // const [newAttachment, setNewAttachment] = useState([]);
    const [paymentData, setPaymentData] = useState([])
    // const [reading, setReading] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    // const { callPost, loading } = usePostRequest(()=>{
    //     refreshPage()
    // });
    
    // const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

    // const handleSendEmail = async (ref) => {
    //     if (ref) {
    //         const element = document.getElementById(ref);
    
    //         html2canvas(element, { scale: 2 }).then(async (canvas) => {
    //             const scale = 0.7; // Set the desired scale (70%)
    
    //             // Create a new canvas with scaled dimensions
    //             const scaledCanvas = document.createElement('canvas');
    //             const context = scaledCanvas.getContext('2d');
    //             scaledCanvas.width = canvas.width * scale;
    //             scaledCanvas.height = canvas.height * scale;
    
    //             // Draw the original canvas onto the scaled canvas
    //             context.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, scaledCanvas.width, scaledCanvas.height);
    
    //             // Convert the scaled canvas to an image
    //             const imgData = scaledCanvas.toDataURL('image/jpeg', 1);
    
    //             const pdf = new jsPDF();
    //             const pdfWidth = pdf.internal.pageSize.getWidth();
    //             const pdfHeight = pdf.internal.pageSize.getHeight();
    //             const imgWidth = scaledCanvas.width;
    //             const imgHeight = scaledCanvas.height;
    
    //             // Calculate the ratio needed to fit the image within the PDF dimensions
    //             const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    
    //             // Calculate the new width and height of the image
    //             const newWidth = imgWidth * ratio;
    //             const newHeight = imgHeight * ratio;
    
    //             // Center the image in the PDF
    //             const imgX = (pdfWidth - newWidth) / 2;
    //             const imgY = 0;
    
    //             // Add the image to the PDF
    //             pdf.addImage(imgData, 'JPEG', imgX, imgY, newWidth, newHeight); // Use 'JPEG' format for better compression
    //             pdf.save(`${paymentData?.trade_name}_Payment_${extractDateTime(currentDate)}.pdf`);
    
    //             // Convert the pdf file from Blob to File obj (needed for upload API)
    //             const blobPdf = pdf.output('blob');
    //             const formPdf = new File([blobPdf], `${paymentData?.trade_name}_Payment_${extractDateTime(currentDate)}.pdf`, {
    //                 type: blobPdf.type,
    //             });
                
    //             let file = [];

    //             if(newAttachment){
    //                 file = newAttachment.map((data) => {
    //                     return data?.file_url
    //                 });
    //             }
    
    //             const finalValues = Object.entries({ payment_id: id, attachment: formPdf, additional_attachments: file, filename: `${paymentData?.trade_name}_Payment_${extractDateTime(currentDate)}.pdf` }).map(([key, value]) => ({
    //                 key,
    //                 value,
    //             }));
    
    //             callPost('emails/send_payment', finalValues, true);
    //         });
    //     }
    // };

    const columns = [
        {
            title: 'Payment Item No.',
            dataIndex: 'id',
            key: 'id',
            align: 'center'
        },
        {
            title: 'Particulars',
            dataIndex: 'particulars',
            key: 'particulars',
            align: 'center'
        },
        {
            title: 'Amount',
            dataIndex: 'billing_item_paid_amount',
            key: 'billing_item_paid_amount',
            align: 'right',
            render: (amount) => formatAmount(amount)
        },
        {
            title: 'Balance',
            dataIndex: 'billing_item_balance',
            key: 'billing_item_balance',
            align: 'right',
            render: (amount) => formatAmount(amount)
        },
        {
            title: 'Paid Amount',
            dataIndex: 'billing_item_paid_amount',
            key: 'billing_item_paid_amount',
            align: 'right',
            render: (amount) => formatAmount(amount)
        }
    ];

    // const columns3 = [
    //     {
    //       title: 'Date Added',
    //       dataIndex: 'added_on',
    //       key: 'added_on',
    //       width: '30%',
    //       render: (amount) => formatDate(amount),
    //     },
    //     {
    //       title: 'Attachments',
    //       dataIndex: 'link',
    //       key: 'link',
    //     },
    // ];  

    const componentRef = useRef();
    // const handlePrint = useReactToPrint({
    //     content: () => componentRef.current,
    // });

    async function fetchPaymentData  () {
        setIsLoading(true)
        const response = await UseGetRequest("billing_payments/get_billing_payment", {payment_id: id});
        if (response?.data) {
            // let attachment = response?.data?.data?.attachments?.map((file) => ({
            // ...file,
            // link: (
            //     <SeeAttachment
            //     attachments={[
            //         { file_url: file.file_url, file_name: file.file_name },
            //     ]}
            //     />
            // ),
            // })) 
            // setNewAttachment(attachment)
            let payment_data = response?.data?.payments?.map((data) => ({
                ...data,
                payment_date: data.payment_date ? formatDate(data.payment_date) : "",
                check_date: data.check_date ? formatDate(data.check_date) : "",
                grand_total: data.grand_total ? formatAmount(data.grand_total) : "",
                payment_type: data.mop ? TypeTag(data.mop) : "",
            })) 
            setPaymentData(payment_data[0]);
        } else {
            setPaymentData([])
        }
        setIsLoading(false);
    }
    useEffect(() => {
        fetchPaymentData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

    return (
        <Layout className='page'>
            <Navbar navKey={'credit_payment'}/>
            <Layout className='content-container content-container-print overflow-y'>
                {
                    isLoading ? (
                        <>
                            <Row className='responsive-tab-inline login-right'>
                                <Col span={24} className='center'>
                                    <HashLoader color="#005E30" size={100} />
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <>
                            <Row className='m-4 paper-view'>
                                <Col span={24} className='email-pad' id="preview" ref={componentRef}>
                                    {/* <Row className='mb-5'>
                                        <Col span={24} align="center">
                                            <Image
                                                width='100%'
                                                height="90%"
                                                src={window.form_header}
                                                alt="login-image"
                                                preview={false}
                                            />
                                        </Col>
                                    </Row> */}
                                    <Row className='center mb-4'>
                                        <Col className='divider-text'>
                                            PAYMENT SLIP
                                        </Col>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Col span={18} align="left">
                                            <Space>
                                                <div className='text-sm'>
                                                    Member Name
                                                </div>
                                                <div className='bold-text text-sm'>
                                                    {paymentData?.member_name}
                                                </div>
                                            </Space>
                                        </Col>
                                        <Col span={6} align="left">
                                            <Space>
                                                <div className='text-sm'>
                                                    Payment No.
                                                </div>
                                                <div className='bold-text text-sm'>
                                                    {paymentData?.id}
                                                </div>
                                            </Space>
                                        </Col>
                                    </Row>
                                
                                    <Row className='mb-2'>
                                        <Col span={18} align="left">
                                            <Space>
                                                <div className='text-sm'>
                                                    Payment Type :
                                                </div>
                                                <div className='bold-text text-sm'>
                                                    {paymentData?.payment_type}
                                                </div>
                                            </Space>
                                        </Col>
                                        <Col span={6} align="left">
                                            <Space>
                                                <div className='text-sm'>
                                                    Date :
                                                </div>
                                                <div className='bold-text text-sm'>
                                                    {paymentData?.payment_date}
                                                </div>
                                            </Space>
                                        </Col>
                                    </Row>
                                    {
                                        (paymentData?.mop === "check" || paymentData?.mop === "direct_deposit" || paymentData?.mop === "credit_card") && (
                                            <>
                                                <Row className='mb-2'>
                                                    <Col span={18}>
                                                        <Space>
                                                            <div className='text-sm'>
                                                                Bank Name :
                                                            </div>
                                                            <div className='bold-text text-sm'>
                                                            {paymentData?.bank_name}
                                                            </div>
                                                        </Space>
                                                    </Col>
                                                    <Col span={6}align="left">
                                                        <Space>
                                                            <div className='text-sm'>
                                                                OR Number :
                                                            </div>
                                                            <div className='bold-text text-sm'>
                                                                {paymentData?.or_no}
                                                            </div>
                                                        </Space>
                                                    </Col>
                                                </Row>
                                            </>
                                        )
                                    }
                                
                                    {
                                        paymentData?.mop === "check" && (
                                            <>
                                                <Row className='mb-2'>
                                                    <Col span={18}>
                                                        <Space>
                                                            <div className='text-sm'>
                                                                Check No :
                                                            </div>
                                                            <div className='bold-text text-sm'>
                                                            {paymentData?.check_no}
                                                            </div>
                                                        </Space>
                                                    </Col>
                                                    <Col span={6}align="left">
                                                        <Space>
                                                            <div className='text-sm'>
                                                                Check Date :
                                                            </div>
                                                            <div className='bold-text text-sm'>
                                                                {paymentData?.check_date}
                                                            </div>
                                                        </Space>
                                                    </Col>
                                                </Row>
                                            </>
                                        )
                                    }
                                    {
                                        paymentData?.mop === "direct_deposit" && (
                                
                                            <Row className='mb-2'>
                                                <Col span={18}>
                                                    <Space>
                                                        <div className='text-sm'>
                                                            Customer ID :
                                                        </div>
                                                        <div className='bold-text text-sm'>
                                                        {paymentData?.customer_id}
                                                        </div>
                                                    </Space>
                                                </Col>
                                            </Row>
                                        )
                                    }
                                    {
                                        paymentData?.mop === "gcash" && (
                                            <Row className='mb-2'>
                                                <Col span={18}>
                                                    <Space>
                                                        <div className='text-sm'>Reference Number :</div>
                                                        <div className='bold-text text-sm'>{paymentData?.reference_no}</div>
                                                    </Space>
                                                </Col>
                                            </Row>
                                        )
                                    }
                                    {
                                        paymentData?.mop === "credit_card" && (
                                
                                            <Row className='mb-2'>
                                                <Col span={18}>
                                                    <Space>
                                                        <div className='text-sm'>
                                                            Approval Code :
                                                        </div>
                                                        <div className='bold-text text-sm'>
                                                        {paymentData?.approval_code}
                                                        </div>
                                                    </Space>
                                                </Col>
                                            </Row>
                                        )
                                    }
                                    
                                    <Row gutter={[16, 16]} className=''>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2 custom-table res-scroll'>
                                            {/* <Table
                                                dataSource={paymentData?.details}
                                                columns={columns}
                                                rowKey="id"
                                                pagination={false}
                                            /> */}
                                            <PreviewTable
                                                dataSource={paymentData?.billing_payments}
                                                columns={columns}
                                            />
                                        </Col>
                                    </Row>
                                    {
                                        paymentData?.remarks && (
                                            <Row className='mb-2'>
                                                <Col span={18}>
                                                    <Space>
                                                        <div className='text-sm'>
                                                            Remarks :
                                                        </div>
                                                        <div className='bold-text text-sm'>
                                                            {paymentData.remarks}
                                                        </div>
                                                    </Space>
                                                </Col>
                                                <Col span={6}>
                                                    <Row>
                                                        
                                                    </Row>
                                                </Col>
                                            </Row>
                                        )
                                    }
                                    <Row gutter={[16, 16]}>
                                        <Col span={12}>
                                        
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12} className='p-3 amount-total' align='right'>
                                            Total: {paymentData.grand_total}
                                        </Col>
                                    </Row>
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Row className='m-2'>
                                                <Col align='left text-sm'>
                                                    <Space direction='vertical' gutter={[0, 0]}>
                                                        Prepared By,
                                                        <Image
                                                            // src={OwnerSignature}
                                                            style={{height:'15vh', width: 'auto' }}
                                                            preview={false}
                                                        />
                                                        __________________________
                                                    </Space>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Row className='text-sm'>{window.payment_signatories}</Row>
                                                    <Row className='text-sm'>Credit and Collection</Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='btn-footer me-4'>
                                <Space className='mb-4'>
                                    <Button
                                        onClick={() => navigate('/accounting/payment')}
                                        className='cancel-color btn-header mb-2'
                                    >
                                        Cancel
                                    </Button>
                                
                                    {/* <Button
                                        onClick={() => handleSendEmail('preview')}
                                        className='secondary-btn mb-2 btn-header'
                                        loading={loading}
                                    >
                                        Send to Email
                                    </Button>
                                
                                    <Button
                                        onClick={handlePrint}
                                        type='primary'
                                        className='mb-2 btn-header'
                                    >
                                        Print
                                    </Button> */}
                                </Space>
                            </Row>
                            {/* <Row className='mx-4'>
                                <Col span={24}>
                                    <Table 
                                        columns={columns3} 
                                        dataSource={newAttachment} 
                                        pagination={false}
                                        loading={{
                                            indicator: customSpinner,
                                            spinning: isLoading,
                                        }}
                                    />
                                </Col>
                            </Row> */}
                        </>
                    )
                }
            </Layout>
        </Layout>
    )
}

export default PreviewPayment
